import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

// checkbox + 11 columns (ID, Full Name, Lead Score, Approval Lkl., Brand
// Name, Report Status, Qualified, Income, Acquired, IP Address, Brand Match)
// + trailing view-icon column — keep in sync with LeadsTable.tsx's COLUMNS.
const COLUMN_COUNT = 13;
const SKELETON_ROWS = 8;

export default function LeadsSkeleton() {
  return (
    <Paper variant="outlined" sx={{ mt: 2.25, borderRadius: 2, overflow: "hidden" }}>
      <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
        <Table size="small" sx={{ minWidth: 1620, "& .MuiTableCell-root": { px: 1.25 } }}>
          <TableHead>
            <TableRow>
              {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
                <TableCell key={index}>
                  <Skeleton variant="text" width="70%" height={20} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from({ length: COLUMN_COUNT }).map((_, columnIndex) => (
                  <TableCell key={columnIndex}>
                    <Skeleton variant="text" width="80%" height={18} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width={150} height={20} />
          <Skeleton variant="rectangular" width={120} height={24} sx={{ borderRadius: 1 }} />
        </Stack>
      </Box>
    </Paper>
  );
}
